export var ReaderFontFamily;
(function (ReaderFontFamily) {
    ReaderFontFamily["SERIF"] = "serif";
    ReaderFontFamily["SANS"] = "sans-serif";
    ReaderFontFamily["CURSIVE"] = "cursive";
    ReaderFontFamily["MONOSPACE"] = "monospace";
    ReaderFontFamily["ACCESSIBLE"] = "AccessibleDfA";
    ReaderFontFamily["DUOSPACE"] = "IA Writer Duospace";
    ReaderFontFamily["DYSLEXIC"] = "OpenDyslexic";
})(ReaderFontFamily || (ReaderFontFamily = {}));
export const READER_FONTS = [
    undefined,
    ReaderFontFamily.SERIF,
    ReaderFontFamily.SANS,
    ReaderFontFamily.CURSIVE,
    ReaderFontFamily.MONOSPACE,
    ReaderFontFamily.ACCESSIBLE,
    ReaderFontFamily.DUOSPACE,
    ReaderFontFamily.DYSLEXIC,
];
//# sourceMappingURL=ReaderFontFamily.js.map